import { get, flowRight } from 'lodash';
import mapProps from 'recompose/mapProps';
import {
  default as TextEditorUnstyled,
  TextEditorMediaButtons as TextEditorMediaButtonsUnstyled,
  TextEditorMobileToolbar as TextEditorMobileToolbarUnstyled,
  DraftRenderer as DraftRendererUnstyled,
} from '../../components/text-editor';
import { EXPERIMENT_HASHTAGS } from '../../constants/experiments';
import withCardBackgroundColor from '../../hoc/with-card-background-color';
import withFontClassName from '../../hoc/with-font-class-name';
import withExperiment from '../../hoc/with-experiment';
import getTheme from './get-theme';

const config = {
  mediaBlock: {
    minContentImageWidth: 740,
  },
};

const withTheme = (WrappedComponent, path, props) =>
  flowRight(
    withCardBackgroundColor,
    withFontClassName,
    mapProps(({ cardBackgroundColor, titleFontClassName, contentFontClassName, ...rest }) => {
      const themeConfig = { cardBackgroundColor, titleFontClassName, contentFontClassName };
      return {
        ...rest,
        ...props,
        theme: path ? get(getTheme(themeConfig), path) : getTheme(themeConfig),
      };
    })
  )(WrappedComponent);

const withHashtag = withExperiment({
  enableHashtags: EXPERIMENT_HASHTAGS,
});

export const TextEditor = withTheme(withHashtag(TextEditorUnstyled), undefined, { config });
export const DraftRenderer = withTheme(withHashtag(DraftRendererUnstyled), undefined, { config });
export const TextEditorMediaButtons = withTheme(TextEditorMediaButtonsUnstyled, 'button');
export const TextEditorMobileToolbar = withTheme(TextEditorMobileToolbarUnstyled, 'toolbar');



// WEBPACK FOOTER //
// ./app/components/styled-text-editor/index.js